import React, { useState } from "react";
import { PageHero } from "../components/Section";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useApp } from "../context/AppContext";
import { useToast } from "../hooks/use-toast";
import { sendContact } from "../services/api";
import { IMAGES } from "../data/mock";
import Seo from "../components/Seo";
import { MapPin, Phone, Mail, Send } from "lucide-react";

const Contacts = () => {
  const { t } = useApp();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    try { await sendContact(form); } catch { /* non-blocking */ }
    toast({ title: t("contacts.sent") });
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("contacts.title")} description={t("contacts.sub")} path="/contacts" />
      <PageHero title={t("contacts.title")} subtitle={t("contacts.sub")} image={IMAGES.cellar2} />
      <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12">
        <div>
          <form onSubmit={submit} className="bg-white rounded-2xl border border-border p-8 space-y-5">
            <div>
              <Label className="text-ink/70">{t("contacts.name")}</Label>
              <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2" />
            </div>
            <div>
              <Label className="text-ink/70">{t("contacts.email")}</Label>
              <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2" />
            </div>
            <div>
              <Label className="text-ink/70">{t("contacts.message")}</Label>
              <Textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-2" />
            </div>
            <Button type="submit" className="w-full h-12 bg-wine hover:bg-wine-dark text-white rounded-full gap-2"><Send className="w-4 h-4" /> {t("contacts.send")}</Button>
          </form>
        </div>
        <div className="space-y-6">
          <div className="rounded-2xl overflow-hidden h-56 shadow-md"><img src={IMAGES.vineyard2} alt="Weinberg in der Abendsonne" className="w-full h-full object-cover" /></div>
          {[
            { icon: MapPin, label: t("contacts.address"), value: "MYSYMP AG, Studenstrasse 14B, CH-6207 Nottwil, Switzerland" },
            { icon: Phone, label: t("contacts.phone"), value: "+41 41 938 01 83" },
            { icon: Mail, label: t("contacts.email"), value: "info@myowncuvee.com" },
          ].map((c, i) => (
            <div key={i} className="flex items-center gap-4 bg-white rounded-2xl border border-border p-5">
              <div className="w-12 h-12 rounded-full bg-wine/10 flex items-center justify-center shrink-0"><c.icon className="w-5 h-5 text-wine" /></div>
              <div>
                <p className="text-xs uppercase tracking-wider text-ink/50">{c.label}</p>
                <p className="text-ink font-medium">{c.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contacts;
